/**
 * Hook pour le tracking des pages visitées
 * Envoie les données d'analytics au backend
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function usePageTracking() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Ne pas tracker certaines pages
    const excludedPaths = ['/login', '/register', '/forgot-password', '/reset-password'];
    if (excludedPaths.some(path => location.pathname.startsWith(path))) {
      return;
    }

    // Envoyer le tracking
    const trackPage = async () => {
      try {
        await axios.post(`${BACKEND_URL}/api/admin/analytics/track`, {
          page: location.pathname,
          user_id: user?.id || null,
          referrer: document.referrer || null
        });
      } catch {
        // Ignorer les erreurs de tracking
      }
    };

    // Délai pour éviter le tracking lors de la navigation rapide
    const timer = setTimeout(trackPage, 1000);
    
    return () => clearTimeout(timer);
  }, [location.pathname, user?.id]);
}

export default usePageTracking;
